module.exports = __webpack_public_path__ + "static/media/CIG-1920x1080-5.7eb63500.png";